import React from 'react'
import { Navigate } from 'react-router-dom'
import { AuthForm } from '../../../../components/AuthForm/AuthForm'
import { LoadingForm } from '../../../../components/LoadingForm/LoadingForm'
import { Title } from '../../../../components/Title/Title'
import { ROUTES } from '../../../../constants/routes'
import { useLogout } from './hooks/useLogout'
import { useRouter } from '../../../../hooks/useRouter'
import { toSingleQueryValue } from '../../../../utils/query-params'
import { useAuth } from '../../../../hooks/useAuth'

export const Logout = (): React.ReactElement => {
  const { query } = useRouter()
  const { goto } = toSingleQueryValue(query)
  const { user } = useAuth()
  const { isLoading, isError } = useLogout()

  if (isLoading && !isError && user) {
    return (
      <AuthForm useProgress={false}>
        <Title value="Logout" />
        <LoadingForm />
      </AuthForm>
    )
  }

  if (goto) {
    return <Navigate to={goto} replace />
  }

  return <Navigate to={ROUTES.LOGIN} replace />
}
